/**
 * One source of truth for currency defaults, shared by the API and the web app
 * so onboarding, provisioning and the settings screen cannot drift apart.
 *
 * The default is UGX. It is a *default*, not a rule: a business picks its own
 * currency at onboarding and can change it later in settings, and every screen
 * formats money from that setting rather than from anything hardcoded.
 */
export const DEFAULT_CURRENCY = 'UGX';
export const DEFAULT_CURRENCY_SYMBOL = 'USh';
/** Best-effort symbols. A business can type its own in settings. */
export const CURRENCY_SYMBOLS = {
    UGX: 'USh', KES: 'KSh', TZS: 'TSh', RWF: 'FRw', NGN: '₦', GHS: '₵',
    ZAR: 'R', USD: '$', EUR: '€', GBP: '£', JPY: '¥', CNY: '¥', INR: '₹',
    AED: 'د.إ', SAR: '﷼', BRL: 'R$', MXN: '$', CAD: '$', AUD: '$',
};
/**
 * Currencies with no minor unit in everyday use. Prices are whole numbers, so
 * a shop is not asked to think about fractions of a shilling.
 */
const ZERO_DECIMAL_CURRENCIES = new Set(['UGX', 'RWF', 'JPY', 'KRW', 'VND', 'CLP', 'ISK']);
/** A short, honest list. Any ISO 4217 code a business types in is accepted. */
export const COMMON_CURRENCIES = [
    'UGX', 'KES', 'TZS', 'RWF', 'NGN', 'GHS', 'ZAR', 'USD', 'EUR', 'GBP', 'INR', 'AED',
];
export function currencySymbolFor(currency) {
    const code = currency.trim().toUpperCase();
    return CURRENCY_SYMBOLS[code] ?? code;
}
export function decimalPlacesFor(currency) {
    return ZERO_DECIMAL_CURRENCIES.has(currency.trim().toUpperCase()) ? 0 : 2;
}
//# sourceMappingURL=currency.js.map